<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-row style="text-align: center !important">
          <ion-col size="3">
            <ion-buttons>
              <ion-back-button text="" :default-href="pageDefaultBackLink" v-if="!hideBackButton"></ion-back-button>
            </ion-buttons>
          </ion-col>
          <ion-col size="6">
            <!--<ion-img :src="require('@/img/logo_new.png')" router-link="/" style="height: 30% !important; max-height:5px !important;"></ion-img>-->
            <ion-buttons router-link="/">
              <img v-bind:src="require('@/img/logo_new.png')" style="padding: 0px; height: 44px; margin: auto !important" />
            </ion-buttons>
          </ion-col>
          <ion-col size="3">
            <ion-buttons router-link="/Impostazioni" v-if="store.Rst_codi">
              <img
                v-bind:src="require('@/img/flag/' + store.Rst_codi + '.gif')"
                style="padding: 0px; height: 18px !important; margin: auto !important; margin-top: 13px"
              />
            </ion-buttons>
          </ion-col>
        </ion-row>
      </ion-toolbar>
    </ion-header>
    <ion-content><slot /></ion-content>
    <ion-footer>
      <ion-row>
        <ion-col style="text-align: center">
          <span style="font-size: 10px">{{ store.Con_rag1 }} {{ store.Ind_ind1 }}, {{ store.Cap_cod1 }} {{ store.Ind_loc1 }} {{ store.Naz_cod1 }}</span>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center">
          <span style="font-size: 10px">Tel. {{ store.Ind_tel1 }} - E-Mail {{ store.Ind_ema1 }}</span>
        </ion-col>
      </ion-row>
    </ion-footer>
  </ion-page>
</template>

<script>
import { IonPage, IonHeader, IonContent, IonToolbar, IonFooter, IonRow, IonCol, IonBackButton, IonButtons } from "@ionic/vue";
// eslint-disable-next-line no-unused-vars
import { store } from "../../components/shared/store";

export default {
  props: ["pageTitle", "pageDefaultBackLink", "hideBackButton", "Bandiera"],
  components: {
    IonPage,
    IonHeader,
    //IonImg,
    IonContent,
    IonToolbar,
    IonFooter,
    IonRow,
    IonCol,
    IonBackButton,
    IonButtons,
    //store
  },
  data() {
    return { store };
  },
};
</script>
